/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_UnlinkInputs */

const en_common_unlink = /** @type {(inputs: Common_UnlinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unlink`)
};

const es_common_unlink = /** @type {(inputs: Common_UnlinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desvincular`)
};

/**
* | output |
* | --- |
* | "Unlink" |
*
* @param {Common_UnlinkInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const common_unlink = /** @type {((inputs?: Common_UnlinkInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_UnlinkInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_common_unlink(inputs)
	return en_common_unlink(inputs)
});